import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

import img_bell from '../../assets/images/notifiche.svg'
import img_close from '../../assets/images/close.svg'
import { TitleH2 } from "../../components/TitleH2";
import { Text } from "../../components/Text";
import { Button } from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { closeCommunicationModal, selectCurrentNotificationData } from "./notificationSlice";
import SecureImage from "../../components/_partials/SecuredImage";
import { API_URL } from "../../config/constants";
import { useEffect } from "react";
import Anchor from "../../components/Anchor";

export default function GlobaNotificationModal () {

    const modalData = useSelector(selectCurrentNotificationData)
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const onConfirm = () => {
        console.log(modalData);
        
        dispatch(closeCommunicationModal(modalData?.notification_data?.communication_id))
    }

    useEffect(() => {
        console.log(modalData);
    }, [modalData])

    return(
        <Modal
            show={modalData?.show}
            onHide={onConfirm}
            keyboard={false}
            centered
        >
            <Modal.Body>
                <div className="d-flex justify-content-end">
                    <img src={img_close} alt="" className="pointer" onClick={onConfirm} />
                </div>
                <div className="d-flex justify-content-center">
                    {
                        modalData?.notification_data?.icon_image_url ?
                            <SecureImage imageUrl={`${API_URL}${modalData?.notification_data?.icon_image_url}`} height="20px" width="20px" className="mx-center" /> :
                        <img src={img_bell} alt="" className="mx-center" />
                    }
                    
                </div>
                <TitleH2 className="text-center mt-2">{modalData?.notification_data?.title}</TitleH2>
                <Text className="text-center mb-4">{modalData?.notification_data?.text}</Text>
                {
                    modalData?.notification_data?.link &&
                        <Anchor href={modalData?.notification_data?.link} target="_blank" className="d-block mb-2 text-center">
                            {t.notifications.discover_more}
                        </Anchor>
                }
                {
                    modalData?.notification_data?.cta &&
                        <a href={modalData?.notification_data?.cta?.url} target="_blank">
                            <Button className="mt-2 w-100 mx-auto">
                                {modalData?.notification_data?.cta?.title}
                            </Button>
                        </a>
                }
                <Button className="mt-2 w-100 mx-auto" onClick={onConfirm} color="secondary">{ t.modals.close}</Button>
            </Modal.Body>
        </Modal>
    )
}